import { render, staticRenderFns } from "./ReporteSaldosPartidasView.vue?vue&type=template&id=57b77e1a&"
import script from "./ReporteSaldosPartidasView.vue?vue&type=script&lang=js&"
export * from "./ReporteSaldosPartidasView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports